import { render, staticRenderFns } from "./FileRefreshButton.vue?vue&type=template&id=b74d36e6&scoped=true&lang=html"
import script from "./FileRefreshButton.vue?vue&type=script&lang=js"
export * from "./FileRefreshButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b74d36e6",
  null
  
)

export default component.exports